
import { useState, useEffect, useRef, useMemo } from 'react';
import { useUserContext, useUserDispatch } from '../contexts/UserContext';
import { useCarts } from '../contexts/CartContext';
import { deCrypt } from "../api/enCrypt";

import { Link, NavLink, useNavigate } from "react-router"
import { 
    Bars3Icon, 
    BellIcon, 
    ShoppingCartIcon, 
    MagnifyingGlassIcon, 
    UserCircleIcon    
} from '@heroicons/react/24/outline'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronRightIcon, ArrowRightCircleIcon,
    IdentificationIcon, HomeIcon, 
    ClipboardDocumentCheckIcon, CurrencyDollarIcon, TruckIcon ,
    DocumentChartBarIcon, WalletIcon,
    } from "@heroicons/react/16/solid";
  

const navigation = [
  { name: 'Home', href: '/', current: true },
  { name: 'Store', href: '/products', current: false },
  // { name: 'Shop', href: '#sector2', current: false },
  { name: 'Hot price', href: '/c/hotprice', current: false },
]

const settings = [
    { name: 'Profile', href: '/', current: true },
    { name: 'Dashboard', href: '/', current: false },
];

const AdminMenu = [
    { name: 'Dashboard', href: '/admin', icon: HomeIcon },
    {
      name: 'Reports',
      href: '/admin/reports',
      icon: DocumentChartBarIcon ,
    },
  
    {
      name: 'Invoices',
      href: '/admin/invoices',
      icon: CurrencyDollarIcon ,
    },
    {
      name: 'Users',
      href: '/admin/users',
      icon: IdentificationIcon ,
    },
    { name: 'Products', href: '/admin/products', icon: TruckIcon  },
    { name: 'Stocks', href: '/admin/stocks', icon: ClipboardDocumentCheckIcon  },
];

const customerMenu = [
    { name: 'สินค้าทั้งหมด', href: '/products', icon: HomeIcon },
    {
      name: 'ไอที',
      href: '/c/ไอที',
      icon: DocumentChartBarIcon ,
    },
  
    {
      name: 'แฟชั่น',
      href: '/c/แฟชั่น',
      icon: CurrencyDollarIcon ,
    },
    {
      name: 'เทรนด์',
      href: '/c/เทรนด์',
      icon: IdentificationIcon ,
    },
    { name: 'ฮอต', href: '/c/ฮอต', icon: TruckIcon  },
    { name: 'แคมป์ปิ้ง', href: '/c/แคมป์ปิ้ง', icon: ClipboardDocumentCheckIcon  },
];


function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function Navbar() {
    const [items, setItems] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const inputRef = useRef()
    const user = useUserContext()
    const cart = useCarts()

    const cartItems = cart.reduce((sum, item) => sum + item.quantity, 0);

    const dispatch = useUserDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        const token = sessionStorage.getItem("token");
      // if (!user.isLogin) {
        if(token) {
            // console.log(token);
            const data = JSON.parse(deCrypt(token));
            // console.log(data);
            dispatch({
              type: 'login',
              user: data,
            });
        }
          // return;
    },[!user.isLogin])
    

    const filterItems = useMemo(() => {
        return items.filter(item => {
            return item.toLowerCase().includes(searchValue.toLowerCase())
        })

        //const keys = ["first_name", "last_name", "email"]
        //items.filter((item) => keys.some((key) => item[key].toLowerCase().includes(searchValue.toLowerCase())))

    },[items, searchValue])

    const handleLogout = () => {
        
        dispatch({
            type: 'logout',
          });

          navigate("/login");    
      }

    // const handleInputChange = (e) => {
    //     setSearchValue(e.target.value);
    //     // const prods = products.filter(pd => pd.name.includes(e.target.value))
    //     // // console.log(prods);
    //     // if(prods.length>0) {
    //     //   setProdFilter(prods);
    //     // }
    //   }

    //   console.log(cart)

  return (
    <div  className="flex w-full  sticky top-0 z-10 items-center justify-between text-lg h-16 text-slate-400 px-4 rounded-b-xl bg-cyan-900">
        <div className="flex items-center">
            <Link to="/" alt="Home">
                <img alt="NJShop" className="h-12 w-12 sm:h-16 sm:w-16 p-1 rounded-full"
                    src="/njshop.png" 
                />
            </Link>
            <div className="flex sm:hidden items-center justify-start text-sm">
                <Menu as="div">
                    <MenuButton className="flex  items-center">
                        <Bars3Icon className="h-8 w-8 text-sky-600 hover:text-sky-300 hover:cursor-pointer" />
                    </MenuButton>
                    {!user.isLogin && 
                    <MenuItems
                        transition
                        className="absolute left-2 z-40 p-2 w-40 mt-2 origin-top-right rounded-md text-gray-300 bg-slate-800 py-1 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-10 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        {navigation.map((item) => (
                            <MenuItem key={item.name}>
                                <a
                                    href={item.href}
                                    alt={item.href}
                                    className="block px-4 py-2 text-sm text-start data-[focus]:bg-sky-800 data-[focus]:outline-none hover:rounded-xl border-b"
                                >
                                    {item.name}
                                </a>
                            </MenuItem>
                        ))}
                    </MenuItems>
                    }
                    <MenuItems
                        transition
                        className="absolute left-2 z-40 p-2 w-40 mt-2 origin-top-right rounded-md text-gray-300 bg-slate-300 py-1 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-10 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        {user.isLogin && user.user.isAdmin ? (
                            AdminMenu.map((menu) => {
                                const LinkIcon = menu.icon;
                                return (
                                    <MenuItem key={menu.name}>
                                        <NavLink
                                            key={menu.name}
                                            to={menu.href} 
                                            className='flex h-[28px] grow items-center justify-start gap-2 rounded-md text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600'
                                            end
                                        >
                                            <LinkIcon className="w-4" />
                                            <p className="block">{menu.name}</p>
                                        </NavLink>
                                    </MenuItem>
                                );
                            })
                        ) : (
                            customerMenu.map((menu) => {
                                const LinkIcon = menu.icon;
                                return (
                                    <MenuItem key={menu.name}>
                                        <NavLink
                                            key={menu.name}
                                            to={menu.href} 
                                            className='flex h-[28px] grow items-center justify-start gap-2 rounded-md text-sm text-black font-medium hover:bg-sky-300 hover:text-blue-600'
                                            end
                                        >
                                            <LinkIcon className="w-4" />
                                            <p className="block">{menu.name}</p>
                                        </NavLink>
                                    </MenuItem>
                                );
                            })
                        )}
                    </MenuItems>
                </Menu>
            </div>
            <div className="justify-center ">
                <div className="hidden sm:ml-2 sm:block">
                    <div className="flex space-x-4">
                    {navigation.map((item) => (
                        <NavLink
                            key={item.name}
                            to={item.href}
                            className='text-gray-300 hover:border-b-2 hover:border-slate-400  hover:text-teal-500 rounded-md px-1 py-2 text-sm'
                        >
                            {item.name}
                        </NavLink>
                    ))}
                    </div>
                </div>
            </div>
        </div>
        {/* <div className="">
            <label className="relative block">
              <span className="sr-only">Search</span>
              <span className="absolute top-1 left-0 flex items-center pl-1">
                <MagnifyingGlassIcon  className="h-5 w-5" />
              </span>
              <input ref={inputRef} className="text-sm placeholder:italic placeholder:text-slate-300 text-slate-600 block bg-white w-full border border-slate-300 rounded-md py-1 pl-7 pr-2 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1" 
                placeholder="Search product..." 
                type="text" 
                name="search"
                value={searchValue}
                onChange={handleInputChange}
              />
            </label>
        </div> */}

        <div className="flex items-center ml-2 gap-2">
            <BellIcon className="h-6 w-6 text-slate-500 rounded-full bg-cyan-800 hover:text-blue-300 hover:cursor-pointer" />
            <Link to="/checkout" className="flex px-2">
                <ShoppingCartIcon className={cart.length>0 ? "h-6 w-6 text-lime-600 hover:text-lime-300" : "h-6 w-6 text-slate-500 bg-cyan-800 rounded-full"} />
                {cart.length>0 && 
                    <span className="relative text-center text-xs text-white justify-center items-center  -top-1 -left-2 bg-red-600 w-4 h-4 rounded-full   ">
                        {/* {cart.length} */}
                        {cartItems}
                    </span>
                }
            </Link>
            <Menu as="div">
                <MenuButton className="flex items-center">
                    {user.isLogin ?
                        <div className="flex w-10 h-10 rounded-full hover:shadow-md hover:shadow-teal-400 ">
                            <img 
                                src={`${process.env.REACT_APP_URL}/image/users/${user.user?.Avatar}`} 
                                alt={user.user?.name}
                                className="rounded-full" />
                        </div> 
                    :
                        <UserCircleIcon className="h-6 w-6 text-gray-500 hover:text-sky-600 hover:cursor-pointer" />
                    }
                </MenuButton>
                <MenuItems
                    transition
                    className="absolute right-2 top-14 z-40 p-2 w-40 origin-top-right rounded-md text-gray-300 bg-slate-600 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-10 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    {user?.isLogin? (
                        <>
                        {settings.map((item) => (
                            <MenuItem key={item.name}>
                                <a
                                    href={item.href}
                                    alt={item.href}
                                    className="block px-4 py-2 text-sm text-start data-[focus]:bg-sky-800 data-[focus]:outline-none hover:rounded-xl border-b"
                                >
                                    {item.name}
                                </a>
                            </MenuItem>
                        ))}
                            <MenuItem key="logout">
                                <button 
                                    onClick={handleLogout}
                                    className="px-4 mt-2 py-1 w-full rounded-lg bg-cyan-700   text-slate-300 hover:bg-red-500 ">
                                    Logout
                                </button>
                            </MenuItem>
                        </>
                        )
                        : 
                        (
                            <div className="flex flex-wrap text-sm gap-2 items-center justify-center p-2">
                                <Link to="/login" className=" w-full px-4 py-1 rounded-xl bg-blue-700 text-slate-300 hover:bg-blue-500 ">Login</Link>
                                <Link to="/register" className="w-full px-4 py-1 rounded-xl bg-green-700 text-slate-300 hover:bg-green-500">Register</Link>
                            </div>                        
                        )
                    }
                </MenuItems>
            </Menu>
        </div>
     
    </div>
    
  )
}
